import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DropdownField from './FormDropdown';
import ProfileModal from './ProfileModal';

const Header = ({ selectedTab, showLogo, pageName, showDropDown, code }) => {
  const navigate = useNavigate();
  // const { auth } = useAuth();
  const [visible, setVisible] = useState(false);

  const links = {
    200: '/material-movements',
    300: '/maintenance',
    400: '/dmu',
    500: '/kpi',
    600: '/pre-start-check',
    700: '/user-management',
    800: '/asset-tracking',
  };
  const handleChange = (value) => {
    window.location.href = `${links[value]}`;
  };
  return (
    <>
      <div className={`d-flex justify-content-between navbar-collapse`}>
        <div className="navbar-text text-dark">{pageName}</div>

        <div className="d-flex gap-2 justify-content-end align-items-center dropdown-icon-container">
          <div className="header-dropdown">
            <DropdownField
              selectedOptions={200}
              allOptions={[
                { name: 'Material Movements', value: 200 },
                { name: 'Maintainence', value: 300 },
                { name: 'DMU', value: 400 },
                { name: 'KPIs', value: 500 },
                { name: 'Pre-start Checks', value: 600 },
                { name: 'Manage Users', value: 700 },
                { name: 'Asset Tracking', value: 800 },
              ]}
              handleChange={(event, optionValue) => {
                handleChange(optionValue);
              }}
            />
          </div>

          <div className="avatar-circle small-avatar">
            <i className="fa-regular fa-bell"></i>
          </div>
          <div
            className="avatar-circle small-avatar color-white"
            onClick={() => setVisible(!visible)}
          >
            {/* {auth?.userData?.firstName?.charAt(0)}
            {auth?.userData?.lastName?.charAt(0)} */}
          </div>
        </div>
      </div>

      {visible && (
        <ProfileModal setVisible={setVisible} className="profilemodal" />
      )}
    </>
  );
};

export default Header;
